"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabTitle = exports.TabStyles = exports.TabButton = exports.StyledContainer = exports.NewTabIcon = exports.ExtraContent = exports.CloseIconWrapper = exports.CloseIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var clearfix = (0, _ykbStyledComponents.css)(["*zoom:1;&:before,&:after{display:table;line-height:0;content:'';}&:after{clear:both;}"]);
var tabSize = function tabSize(props) {
  var selectedSize = props.$size || 'medium';
  if (selectedSize !== 'small' && selectedSize !== 'medium' && selectedSize !== 'large') {
    return '';
  }
  return (0, _ykbStyledComponents.css)([".", "{&-nav-container{font-size:", ";}&-tab{margin-right:0;}}"], function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.tabs.navigation.tabs.size[selectedSize].fontSize;
  });
};
var ExtraContent = exports.ExtraContent = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1tjefnk-0"
})(["line-height:32px;"]);
var TabButton = exports.TabButton = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1tjefnk-1"
})(["position:relative;display:inline-flex;align-items:center;"]);
var TabTitle = exports.TabTitle = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1tjefnk-2"
})(["", ""], function (props) {
  return props.$width && (0, _ykbStyledComponents.css)(["width:", "px;"], props.$width);
});
var NewTabIcon = exports.NewTabIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-1tjefnk-3"
})([""]);
var CloseIconWrapper = exports.CloseIconWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1tjefnk-4"
})([""]);
var CloseIcon = exports.CloseIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-1tjefnk-5"
})([""]);
var TabStyles = exports.TabStyles = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1tjefnk-6"
})(["", "{width:", ";height:", ";text-align:center;cursor:pointer;border-radius:", ";border:", " ", " ", ";font-size:", ";color:", ";transition:all 0.3s;&:hover{color:", ";border-color:", ";}}.", "{box-sizing:border-box;position:relative;overflow:hidden;", " color:", ";margin-bottom:10px;.", "-ink-bar{z-index:1;position:absolute;left:0;bottom:1px;box-sizing:border-box;height:2px;background-color:", ";transform-origin:0 0;}&-bar{border-bottom:", "  ", " ", ";outline:none;}&-nav-container{overflow:hidden;font-size:", ";line-height:", ";box-sizing:border-box;position:relative;white-space:nowrap;margin-bottom:-1px;", " &-scrolling{padding-left:32px;padding-right:32px;padding-left:2em;padding-right:2em;}}&-tab-prev,&-tab-next{user-select:none;z-index:2;width:0;height:100%;line-height:32px;line-height:2em;cursor:pointer;border:0;background-color:transparent;position:absolute;text-align:center;color:", ";font-size:", ";transition:width 0.3s  ", ",opacity 0.3s ", ",color 0.3s ", ";opacity:0;pointer-events:none;&.", "-tab-arrow-show{opacity:1;width:2em;height:100%;pointer-events:auto;}&:hover{color:", ";}&-icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center;text-transform:none;}}&-tab-btn-disabled{cursor:not-allowed;&,&:hover{color:", ";}}&-tab-next{right:2px;", "{display:inline-block;vertical-align:middle;}}&-tab-prev{left:0;", "{display:inline-block;vertical-align:middle;}:root &{filter:none;}}&-nav-wrap{overflow:hidden;margin-bottom:-1px;}&-nav-scroll{overflow:hidden;white-space:nowrap;}&-nav{box-sizing:border-box;padding-left:0;transition:transform 0.5s ", ";position:relative;margin:0;list-style:none;display:inline-block;&:before,&:after{display:table;content:' ';}&:after{clear:both;}.", "-tab-disabled{pointer-events:none;cursor:default;color:", ";}.", "-tab{display:inline-flex;align-items:center;vertical-align:middle;height:100%;margin-right:24px;box-sizing:border-box;position:relative;&:last-child{margin-right:0;}&-title{display:inline-block;vertical-align:middle;}&-ellipsis-title{display:inline-block;vertical-align:middle;text-overflow:ellipsis;overflow:hidden;}", "{display:inline-block;vertical-align:middle;line-height:0px;}", "{color:", ";margin-left:", ";font-size:", ";&:hover{color:", ";}}margin:", ";transition:color 0.3s ", ";cursor:pointer;text-decoration:none;&:hover{color:", ";}&:active{color:", ";}}.", "-tab-active{color:", ";}}& > .", "-content{padding:", ";}&.tab-horizontal{.", "-content{width:100%;.", "-tabpane{flex-shrink:0;width:100%;transition:opacity 0.45s;opacity:1;}> .", "-tabpane-inactive{opacity:0;height:0;padding:0 !important;pointer-events:none;}}.", "-content-animated{display:flex;flex-direction:row;will-change:margin-left;transition:margin-left 0.3s ", ";padding-left:0px;padding-right:0px;}}&.tab-vertical{.", "-bar{border-bottom:0;height:100%;.", "-tab{float:none;display:block;margin:0px 24px 16px 0px;padding:", ";&:last-child{margin-bottom:0;}}.", "-nav-scroll{width:auto;}.", "-nav-container,.", "-nav-wrap{height:100%;}.", "-nav-container{margin-bottom:0;&.", "-nav-container-scrolling{padding:32px 0;}}.", "-nav-wrap{margin-bottom:0;}.", "-ink-bar{width:2px;left:auto;height:auto;top:0;}}.", "-content{overflow:hidden;width:auto;margin-top:0 !important;}.", "-bar{.", "-tab-next{width:100%;bottom:0;height:32px;}.", "-tab-prev{top:0;width:100%;height:32px;}}&.", "-left{display:flex;width:100%;> .", "-bar{float:left;order:0;border-right:", " ", " ", ";margin-right:-1px;margin-bottom:0;.", "-tab{text-align:right;}.", "-nav-container{margin-right:-1px;}.", "-nav-wrap{margin-right:-1px;}.", "-ink-bar{right:1px;}}> .", "-content{padding-left:24px;flex:1 auto;border-left:", " ", " ", ";}}&.", "-right{display:flex;width:100%;> .", "-bar{float:right;order:1;border-left:", " ", " ", ";margin-left:-1px;margin-bottom:0;.", "-nav-container{margin-left:-1px;}.", "-nav-wrap{margin-left:-1px;}.", "-ink-bar{left:1px;}}> .", "-content{padding-right:24px;flex:1 auto;border-right:", " ", " ", ";}&.tab-card{.", "-tab{border-right:1px solid ", " !important;}}}}}.", "-bottom > .", "-bar{margin-bottom:0;margin-top:16px;}.", "-top .", "-ink-bar-animated,.", "-bottom .", "-ink-bar-animated{transition:transform 0.3s  ", ",width 0.3s ", ";};.", "-left .", "-ink-bar-animated,.", "-right .", "-ink-bar-animated{transition:transform 0.3s ", ",height 0.3s ", ";}.tab-noAnimation,.tab-vertical{.", "-content{&-animated{transform:none !important;margin-left:0 !important;}> .", "-tabpane-inactive{display:none;}}}.tab-card{&.", " > .", "-bar{border-bottom:0;.", "-nav-container{height:", ";margin-bottom:0;}.", "-ink-bar{visibility:hidden;}.", "-tab{margin:0;border:", " ", " ", ";border-right:0;border-radius:", " ", " 0 0;background:", ";transition:all 0.3s ", ";padding:0 16px 0 16px;transition:all 0.3s ", ";line-height:30px;&:last-child{border-right:", " ", " ", ";}&.", "-tab-active{background:", ";border-color:", ";color:", ";border-bottom:1px solid #fff;}&.", "-tab-inactive{padding:0;}}.", "-nav-wrap{margin-bottom:0;}}.", "-content{border:", " ", " ", ";border-radius:0px ", " ", " ", ";.", "-tabpane{transition:none !important;.", "-inactive{overflow:hidden;}}}.tab-vertical{.", " > .", "-bar{.", "-nav-container{height:auto;}.", "-tab{border-bottom:", " ", " ", " !important;margin-bottom:-1px;.", "-active{padding-bottom:4px;}&:last-child{margin-bottom:8px;}}", "{width:90%;}}.", "-left > .", "-bar{.", "-nav-wrap{margin-right:0;}.", "-tab{border-right:0;border-radius:", " 0 0 ", ";margin-right:1px;&-active{margin-right:-1px;padding-right:18px;}}}.", "-right > .", "-bar{.", "-nav-wrap{margin-left:0;}.", "-tab{border-left:0;border-radius:0 ", " ", " 0;margin-left:1px;&-active{margin-left:-1px;padding-left:18px;}}}}.tab-bottom{.", "-bar{position:relative;z-index:1;margin-top:-1px;}.", "-tab{border-top:1px solid ", " !important;border-bottom:1px solid ", " !important;border-radius:0 0 ", " ", " !important;&-active{border-top:1px solid white !important;}}.", "-content{border-radius:0px ", " ", " 0px;}}&:not(.tab-bottom):not(.tab-vertical){.", "-bar{margin-bottom:-1px;}}}", " ", ";"], NewTabIcon, function (props) {
  return props.theme.tabs.addTabButton.width;
}, function (props) {
  return props.theme.tabs.addTabButton.height;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.theme.tabs.border.width;
}, function (props) {
  return props.theme.tabs.border.style;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.theme.tabs.addTabButton.fontSize;
}, function (props) {
  return props.theme.tabs.addTabButton.color;
}, function (props) {
  return props.theme.tabs.addTabButton.hover.color;
}, function (props) {
  return props.theme.tabs.addTabButton.hover.borderColor;
}, function (props) {
  return props.prefixCls;
}, function () {
  return clearfix;
}, function (props) {
  return props.theme.tabs.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.bar.inkLineColor;
}, function (props) {
  return props.theme.tabs.border.width;
}, function (props) {
  return props.theme.tabs.border.style;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.theme.tabs.navigation.fontSize;
}, function (props) {
  return props.theme.tabs.navigation.lineHeight;
}, clearfix, function (props) {
  return props.theme.tabs.navigation.arrows.color;
}, function (props) {
  return props.theme.tabs.navigation.arrows.iconSize;
}, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.navigation.arrows.hoverColor;
}, function (props) {
  return props.theme.tabs.navigation.arrows.disabledColor;
}, _StyledIcon.default, _StyledIcon.default, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.navigation.tabs.disabledColor;
}, function (props) {
  return props.prefixCls;
}, CloseIconWrapper, CloseIcon, function (props) {
  return props.theme.tabs.navigation.tabs.closeIcon.color;
}, function (props) {
  return props.theme.tabs.navigation.tabs.closeIcon.marginLeft;
}, function (props) {
  return props.theme.tabs.navigation.tabs.closeIcon.fontSize;
}, function (props) {
  return props.theme.tabs.navigation.tabs.closeIcon.hoverColor;
}, function (props) {
  return props.theme.tabs.navigation.tabs.padding;
}, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.theme.tabs.navigation.tabs.hoverColor;
}, function (props) {
  return props.theme.tabs.navigation.tabs.pressedColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.navigation.tabs.activeColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.content.padding;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.navigation.tabs.vertical.padding;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.width;
}, function (props) {
  return props.theme.tabs.border.style;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.width;
}, function (props) {
  return props.theme.tabs.border.style;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.width;
}, function (props) {
  return props.theme.tabs.border.style;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.width;
}, function (props) {
  return props.theme.tabs.border.style;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.navigation.tabs.card.height;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.width;
}, function (props) {
  return props.theme.tabs.border.style;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.theme.tabs.navigation.tabs.card.backgroundColor;
}, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.theme.tabs.animation;
}, function (props) {
  return props.theme.tabs.border.width;
}, function (props) {
  return props.theme.tabs.border.style;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.navigation.tabs.card.activeBackgroundColor;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.theme.tabs.navigation.tabs.card.activeColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.width;
}, function (props) {
  return props.theme.tabs.border.style;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.width;
}, function (props) {
  return props.theme.tabs.border.style;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.prefixCls;
}, NewTabIcon, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.theme.tabs.border.color;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.theme.tabs.border.radius;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.css && props.css;
}, function (props) {
  return props.$size && tabSize(props);
});
var Container = function Container(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    className = _ref.className,
    size = _ref.size,
    type = _ref.type,
    prefixCls = _ref.prefixCls;
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TabStyles, {
    theme: theme,
    prefixCls: prefix,
    $size: size,
    type: type,
    children: children(prefix)
  }));
};
var StyledContainer = exports.StyledContainer = (0, _ykbStyledComponents.default)(Container).withConfig({
  componentId: "ykb-ui__sc-1tjefnk-7"
})([""]);